/*
 * Created Date: 22-01-2024, 4:23:44 pm
 * Author: Victor
 * Email: victor@pt-corp.vn
 * -----
 * Last Modified: Mon Jan 22 2024
 * Modified By: Victor
 * -----
 * Copyright (c) 2024 PT CORP, Inc
 * -----
 * HISTORY:
 * Date      	By	Comments
 * ----------	---	----------------------------------------------------------
 */

import BaseService from '@Core/axios/BaseService'

class SystemService extends BaseService {
	// BASE_URL = 'https://studio.cqfsliyqyzv0gv.flashvps.xyz'
	BASE_URL = 'https://studio-api-07.eduquiz.io.vn'

	constructor(params) {
		super(params)
		this.setRequest()
	}

	getGeneralConfig = () => {
		const endpoint = `/workspace/public/api/v1/settings/general`

		return this.withCache(() => this.request.get(endpoint), endpoint)
	}
}

const systemService = new SystemService()
export default systemService
